import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

export enum DriverStatus {
  ACTIVE = 'Ativo',
  PENDING_APPROVAL = 'Aprovação pendente',
  INCOMPLETE_REGISTRATION = 'Registro incompleto',
  REJECTED = 'Rejeitado',
}

export interface GetDriverStatisticsResponse {
  List: List[];
  driversTotals: DriversTotal[];
}

export interface List {
  username: string;
  DELIVERED: string;
  PROBLEM_REPORTED: string;
  CANCELLED: string;
  REPROCESSED: string;
  RETURNED: string;
  totalKilometers: number;
  totalFaturado: number;
  totalFretes: string;
  mes: Date;
}

export interface DriversTotal {
  STATUS: DriverStatus;
  COUNT: string;
}

export default function useGetDriverStatistics() {
  const [loading, setLoading] = useState(false);

  async function execute(): Promise<GetDriverStatisticsResponse | undefined> {
    try {
      setLoading(true);
      const response = await api.get('v1/backoffice/drivers/statistics');

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      toast.error(ToastMessages.general.error.genericError);
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
